import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import { useTranslation } from "react-i18next";
import { Input, Breadcrumb, Space, Col, Row, Spin } from "antd";
import { getRequest, postRequest, patchRequest } from "../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { ReactComponent as StarFilled } from "../../image/favrouit.svg";
import { ReactComponent as StarOutlined } from "../../image/StarOutlined.svg";
import Image from "../../image/Image.svg";
import SearchIcon from "../../image/SearchIcon.svg";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { authUserData } from "../../utils/Helper";

const CategoryItemSettingList = () => {
  const { Search } = Input;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [state, setState] = useState({
    no_pagination: "true",
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getCategoryList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest("category-tree/?active_category=active", state);

        if (apiResponse.status) {
          const sortedCategories = apiResponse.data.data.sort((a, b) => {
            if (a.favourites?.favourite && !b.favourites?.favourite) return -1;
            if (!a.favourites?.favourite && b.favourites?.favourite) return 1;
            return 0;
          });

          setCategoryList(sortedCategories);
        } else {
          ErrorNotificationMsg(t("error_in_subscription_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getCategoryList();
  }, [state, t]);

  const handleImageClick = (categoryId) => {
    setSelectedCategoryId(categoryId);
    setLoading(true);
    setTimeout(() => {
      navigate("/category-item-setting/edit/" + categoryId);
      setLoading(false);
    }, 1000);
  };

  const handleToggle = (categoryId, favourites) => {
    handleFavourite(categoryId, favourites);
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const handleFavourite = async (favouriteId, favourites) => {
    setLoading(true);
    const payload1 = {
      user: authUserData()?.user_id,
      category_tree: favouriteId,
      favourite: !favourites.favourite,
    };
    const payload2 = {
      user: authUserData()?.user_id,
      category_tree: favouriteId,
      favourite: !favourites.favourite,
    };
    try {
      let response;
      if (favourites.favourite_id === null) {
        response = await postRequest("favourite-category/", payload1);
      } else {
        response = await patchRequest(
          `favourite-category/${favouriteId}/favourite_category_update/${favourites.favourite_id}/`,
          payload2
        );
      }

      if (response.data.success) {
        SuccessNotificationMsg(
          favourites.favourite_id === null
            ? t("favourite_added_successfully")
            : t("favourite_updated_successfully")
        );

        setTimeout(async () => {
          const apiResponse = await getRequest("category-tree/", state);
          setLoading(true);

          if (apiResponse.status) {
            const sortedCategories = apiResponse.data.data.sort((a, b) => {
              if (a.favourites?.favourite && !b.favourites?.favourite) return -1;
              if (!a.favourites?.favourite && b.favourites?.favourite) return 1;
              return 0;
            });
            setCategoryList(sortedCategories);
            setLoading(false);
          } else {
            ErrorNotificationMsg(t("error_in_subscription_list"));
            setLoading(false);
          }
        }, 1000);
      }
    } catch (error) {
      ErrorNotificationMsg(t("error_in_updating_favourite"));
    }
  };

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3> Category Item Setting </h3>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Category Item Setting</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>
      <section className="grid-sec  mt-5">
        <div className="PR-body">
          <Row className="tblheader">
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              className="tbl-heading"
            >
              {/* <h1> Category Item Setting</h1> */}
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-action">
              <div className="searchwrp">
                <Space direction="vertical">
                  {/* <Search
                    prefix={
                      <img
                        src={SearchIcon}
                        alt="SearchIcon"
                        className="SearchIcon"
                        width={22}
                      />
                    }
                    placeholder="Search RFQ"
                    onChange={searchCallbackDelayed}
                    style={{
                      width: 250,
                    }}
                  /> */}
                </Space>
              </div>
            </Col>
          </Row>
          <Spin spinning={loading}>
            <Row gutter={24}>
              {categoryList.map((item) => (
                <Col key={item.id} xs={24} sm={12} md={8} lg={6} xl={4}>
                  <div className="prwrp">
                    <div
                      className={`prcard ${
                        selectedCategoryId === item.id ? "active" : ""
                      }`}
                      onClick={() => handleImageClick(item.id)}
                    >
                      <div className="primg">
                        {item.image ? (
                          <img
                            src={item.image}
                            width={"200px"}
                            height={"36px"}
                            alt={item.name}
                          />
                        ) : (
                          <img
                            src={Image}
                            width={"200px"}
                            height={"36px"}
                            alt={item.name}
                          />
                        )}
                      </div>
                      <div className="prdec">
                        <h3>{item.name}</h3>
                        {/* <h6>
                          <label>Unassigned PR :</label>123
                        </h6>
                        <h6>
                          <label>Assigned PR To Me: </label>10
                        </h6>
                        <h6>
                          <label>Assigned PR To Others: </label>10
                        </h6>
                        <h6>
                          <label>Total Number Of Received PR: </label>5
                        </h6> */}
                      </div>
                    </div>
                    <div
                      className="favroit"
                      onClick={() => handleToggle(item.id, item.favourites)}
                    >
                      {item?.favourites?.favourite ? (
                        <StarFilled className="favroit" />
                      ) : (
                        <StarOutlined className="favroit" />
                      )}
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
            <div className="btnwrp">
              <ButtonField
                className="SaveGradiantBtn"
                type="primary"
                htmlType="View All"
                label="View All"
              />
            </div>
          </Spin>
        </div>
      </section>
    </>
  );
};
export default CategoryItemSettingList;
